export default __webpack_public_path__ + "static/img-app-deployment--mobile-08c1751bc20cb71aabcd2b6e775fcb60.jpg";